import { KeyConstructor } from './keyConstructor';
const AUTH_TOKEN_KEY = 'authToken';
const AUTH_MEMBER_KEY = 'authMember';
const AUTH_MEMBER_SESSIONS_KEY = 'authMemberSessions';
const LOGIN_KEY = 'loginNetwork';
const LOGIN_WITH_SSO_KEY = 'loginWithSso';
const SSOS_KEY = 'ssos';
const MEMBER_INVITATION_VALIDITY_KEY = 'memberInvitationValidity';
const MEMBER_INVITATIONS_KEY = 'memberInvitations';
const MEMBER_INVITATION_VALIDITY_LINK_KEY = 'memberInvitationValidityLink';
const MEMBER_INVITATION_LINK_KEY = 'memberInvitationLink';
const SSO_MEMBERSHIP_KEY = 'ssoMembership';
const SSO_URL_KEY = 'ssoUrl';
export const getAuthTokenKey = KeyConstructor(AUTH_TOKEN_KEY);
export const getAuthMemberKey = KeyConstructor(AUTH_MEMBER_KEY);
export const getAuthMemberSessionsKey = KeyConstructor(AUTH_MEMBER_SESSIONS_KEY);
export const getLoginKey = KeyConstructor(LOGIN_KEY);
export const getLoginWithSsoKey = KeyConstructor(LOGIN_WITH_SSO_KEY);
export const getSsosKey = KeyConstructor(SSOS_KEY);
export const getMemberInvitationValidityKey = KeyConstructor(MEMBER_INVITATION_VALIDITY_KEY);
export const getMemberInvitationLinkKey = KeyConstructor(MEMBER_INVITATION_LINK_KEY);
export const getMemberInvitationsKey = KeyConstructor(MEMBER_INVITATIONS_KEY);
export const getMemberInvitationLinkValidityKey = KeyConstructor(MEMBER_INVITATION_VALIDITY_LINK_KEY);
export const getSsoMembershipKey = KeyConstructor(SSO_MEMBERSHIP_KEY);
export const getSsoUrlKey = KeyConstructor(SSO_URL_KEY);
//# sourceMappingURL=authToken.keys.js.map